export const STENCIL_SUBMISSION_SET_AUTHOR_NAME =
  'STENCIL_SUBMISSION_SET_AUTHOR_NAME';
export const STENCIL_SUBMISSION_SET_AUTHOR_EMAIL =
  'STENCIL_SUBMISSION_SET_AUTHOR_EMAIL';
export const STENCIL_SUBMISSION_SET_CAPTION_TEXT =
  'STENCIL_SUBMISSION_SET_CAPTION_TEXT';
export const STENCIL_SUBMISSION_SET_OPT_IN_NEWSLETTER =
  'STENCIL_SUBMISSION_SET_OPT_IN_NEWSLETTER';
export const STENCIL_SUBMISSION_SET_REMOTE_PREVIEW_IMAGE_URL =
  'STENCIL_SUBMISSION_SET_REMOTE_PREVIEW_IMAGE_URL';
export const STENCIL_SUBMISSION_SET_SHARE_WITH_OTHERS =
  'STENCIL_SUBMISSION_SET_SHARE_WITH_OTHERS ';

export const STENCIL_TEXT_EDITOR_NO_ACTIVE_VIEW =
  'STENCIL_TEXT_EDITOR_NO_ACTIVE_VIEW';

export const STENCIL_TEXT_EDITOR_SET_ACTIVE_VIEW =
  'STENCIL_TEXT_EDITOR_SET_ACTIVE_VIEW';

export const STENCIL_SET_CURRENT_PAGE = 'STENCIL_SET_CURRENT_PAGE';
